import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e16961f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]
const _hoisted_2 = ["xlink:href"]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSvg',
  props: {
    href: null,
    fontSize: { default: '16px' },
    color: null,
    title: null
  },
  setup(__props: any) {

const props = __props as { href?: string, fontSize: string, color?: string, title?: string }



return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (__props.title)
    ? (_openBlock(), _createBlock(_component_a_tooltip, { key: 0 }, {
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock("svg", _mergeProps({
            class: "icon",
            "aria-hidden": "true",
            style: { fontSize: __props.fontSize, color: __props.color }
          }, _ctx.$attrs), [
            _createElementVNode("use", {
              "xlink:href": `#${__props.href}`
            }, null, 8, _hoisted_1)
          ], 16))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("svg", _mergeProps({
        key: 1,
        class: "icon",
        "aria-hidden": "true",
        style: { fontSize: __props.fontSize, color: __props.color }
      }, _ctx.$attrs), [
        _createElementVNode("use", {
          "xlink:href": `#${__props.href}`
        }, null, 8, _hoisted_2)
      ], 16))
}
}

})